import React, { useEffect, useState } from "react";
import { Container, Button, Typography, CircularProgress } from "@mui/material";
import { notification } from "../../utils/Notifications";
import { dailyReportExist, generateDailyReport } from "../../api/guidesApi";
import Title from "../../components/SharedComponents/Title";
import useLogout from '../../hooks/auth/authHook.js';
import styles from './reportStyles.js';
import { usePermissions } from "../../hooks/permissions/usePermissions.js";

const Report = () => {
  const [logout] = useLogout();
  const { hasAllPermissions } = usePermissions();

  const [reportUrl, setReportUrl] = useState('None');
  const [isLoading, setIsLoading] = useState(false);

  const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

  const date = new Date(Date.now());

  const dayName = days[date.getDay()];
  const day = date.getDate();
  const monthName = months[date.getMonth()];
  const year = date.getFullYear();

  const formattedDate = `${dayName} ${day} de ${monthName} del ${year}`;

  const generateReport = () => {
    setIsLoading(true);
    generateDailyReport()
      .then((response) => {
        if (response.data.status_Code === 201) {
          //setGuides(response.data.guides);
          setReportUrl(response.data.url_daily_report);
          notification({
            text: "Reporte generado correctamente",
            type: "success",
          });
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al generar el reporte",
            type: "error",
          });
        }
      })
      .catch(() => {
        notification({ text: 'Error de conexión, revisa tu conexión a internet', type: 'error' });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  
  const checkIfReportExist = () => {
    setIsLoading(true);
    dailyReportExist()
      .then((response) => {
        if (response.data.status_Code === 200) {
          setReportUrl(response.data.url_daily_report)
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
        } else {
          notification({
            text: "Error al generar el reporte",
            type: "error",
          });
        }
      })
      .catch(() => {
        notification({ text: 'Error de conexión, revisa tu conexión a internet', type: 'error' });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  
  const downloadReport = async  () => {
    try {
      window.location.href = reportUrl;
    } catch (error) {
      notification({
        text: "No se pudo descargar el reporte",
        type: "error",
      });
    }
  };

  useEffect(() => {
    checkIfReportExist();
  }, []);

  return (
    <Container
      style={styles.mainContainer}
    >
      <Title title="Reporte" />

      <Container sx={styles.secondaryContainer}>
        <Container sx={{ padding: '0px !important', display: 'flex', flexDirection: 'column'}}>
          <Typography variant="subtitle1" sx={{fontWeight: 'bold'}}>Fecha del reporte</Typography>
          <Typography variant="body2" sx={{paddingBottom: '12px'}}>{formattedDate}</Typography>
          { (reportUrl === 'None') && hasAllPermissions(['rep_vw']) && <Button
            variant="contained"
            onClick={generateReport}
            sx={styles.activeButton}
          >
            {isLoading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              "Generar reporte"
            )}
          </Button>}

          { (reportUrl === 'None') && <Container sx={{height: '12px'}}></Container>}

          { reportUrl !== 'None' && hasAllPermissions(['rep_vw']) && <Button
            variant="contained"
            onClick={downloadReport}
            disabled={reportUrl === 'None' || isLoading}
            sx={(reportUrl === 'None' || isLoading) ? styles.inactiveButton : styles.activeButton}
          >
            {isLoading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              "Descargar reporte"
            )}
          </Button>}
        </Container>
      </Container>
    </Container>
  );
};

export default Report;
